import React from "react";
import { useConfirmFieldChange } from "../../hooks/useConfirmFieldChange";
import { IFormSchemaField } from "../../types";

/**
 * Null-rendering sibling mounted next to a field carrying `ui.confirm` — hosts
 * the confirm-on-change watch without adding a useWatch subscription to every
 * field (the guard is only mounted when the field declares `ui.confirm`).
 */
export const DynamicFieldConfirmGuard: React.FC<{
  field: IFormSchemaField;
  name: string;
}> = ({ field, name }) => {
  useConfirmFieldChange(field, name);
  return null;
};
